import React from "react";
import LegalDoc from "./LegalDoc";

export default function Privacy() {
  const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const url = process.env.REACT_APP_LEGAL_PRIVACY_URL || (apiBase ? `${apiBase}/public/legal/privacy` : "https://storage.googleapis.com/hangrong-legal/legal/privacy-latest.md");
  return <LegalDoc title="Privacy Policy" url={url} />;
}
